import { IPV6_REGEX } from '@kentik/ui-shared/util/regex';

export default {
  fn: (value) => {
    if (!value || typeof value !== 'string') {
      return false;
    }
    return typeof value === 'string' && value.match(IPV6_REGEX);
  },
  message: 'Enter a valid IPv6 address. '
};
